var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: _vm.$style.tooltipContainer
  }, [!_vm.iconHide ? _c('MottoIcon', {
    class: (_class = {}, _class[_vm.$style.iconAbsolutePosition] = _vm.iconAbsolutePosition, _class),
    attrs: {
      "id": _vm.target,
      "data-tooltip-icon": "",
      "name": _vm.iconName,
      "icon-color": _vm.iconColor
    }
  }) : _vm._e(), _c('b-tooltip', {
    attrs: {
      "target": _vm.target,
      "placement": _vm.placement,
      "custom-class": _vm.tooltipClasses
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }